import { Component, ErrorInfo, ReactNode } from "react";
import { Button, Stack, Typography } from "@mui/material";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import ProcessingDataImage from "../../assets/feedback-icons/processing-data.png";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ChartErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error(
      "ChartErrorBoundary: Chart rendering error:",
      error,
      errorInfo,
    );
  }

  resetError = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <Stack
        border={1}
        spacing={2}
        height="100%"
        alignItems="center"
        borderColor="grey.300"
        justifyContent="center"
      >
        <img src={ProcessingDataImage} alt="ProcessingDataImage" width="15%" />

        <Typography variant="body2" fontWeight="medium">
          Oops! Something went wrong loading this chart.
        </Typography>

        <Typography variant="body2">
          Don’t worry — we’ve already spotted the issue and are working on a fix
          behind the scenes. In the meantime, you can try refreshing the chart
          using the button below.
        </Typography>

        <Button onClick={this.resetError} startIcon={<RotateLeftIcon />}>
          Reload The Chart
        </Button>
      </Stack>
    );
  }
}
